import { ethers } from 'ethers';

export const formatEth = (value: bigint): string => {
  return ethers.formatEther(value);
};

export const parseEth = (value: string): bigint => {
  return ethers.parseEther(value);
};

export const formatAddress = (address: string): string => {
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
};

export const getMinimumEthForUSD = async (contract: ethers.Contract, usdAmount: number = 1): Promise<string> => {
  try {
    // Get ETH price from the contract's price feed
    const provider = contract.runner?.provider;
    if (!provider) throw new Error('No provider available');

    // Create a contract instance to call the price converter functions
    // We'll estimate based on current ETH price (this is approximate)
    // For a more accurate calculation, you might want to add a helper function to your contract
    
    // For now, we'll use a simple estimation
    // Assuming 1 ETH = $2500 (this should be fetched from the price feed in a real app)
    const ethPriceInUSD = 2500;
    const minEthRequired = usdAmount / ethPriceInUSD;
    
    // Add a small buffer to ensure the transaction goes through
    const minEthWithBuffer = minEthRequired * 1.1;
    
    return minEthWithBuffer.toFixed(6);
  } catch (error) {
    console.error('Error calculating minimum ETH:', error);
    return '0.0004'; // Fallback minimum
  }
};